import { HttpHeaders, HttpParams } from "@angular/common/http";

export abstract class HttpRequestOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  observe?: "body";
  params?: HttpParams | { [param: string]: string | string[] };
  reportProgress?: boolean;
  responseType?: "json" | any;
  withCredentials?: boolean;
}
